import { isLinkapiGatewayRoutingEnabled } from '@/lib/constants/linkapi-gateway-routing';
import type { ICreditCard } from '@/types';

/**
 * Payment payload for a saved card. With the gateway routing flag on, the
 * card is identified by `credit_card_id`; `token` is still sent so APIs
 * without `credit_card_id` support keep working until the legacy token
 * column is removed.
 */
export function buildSavedCardPayload(
  card: Pick<ICreditCard, 'id' | 'token'>,
  installments?: number,
): ICreditCard {
  const sendCreditCardId = isLinkapiGatewayRoutingEnabled && Boolean(card.id);

  return {
    ...(sendCreditCardId ? { credit_card_id: card.id } : {}),
    ...(card.token ? { token: card.token } : {}),
    installments,
  };
}
